import { CRUD, CrudModel } from '../../classes/crud.class'
import { BaseModelData } from '../base-model-data'
import { EstimateCharge } from '../estimate/estimate-charge'
import { EstimateInputs } from '../estimate/estimate-inputs'
import { EstimateOutput } from '../estimate/estimate-output'

export interface ShopperEstimateViewFields {
  shopperInsurances?: {
    P?: ShopperEstimateInsurance
  }
  eligibilityId?: string
  patientEmail?: string | null
  patientPhone?: string | null
}

export interface ShopperEstimateClinicianData {
  id?: string
  name?: string
}

export interface ShopperEstimateInsurance {
  carrier?: string
  memberId?: string
  eligibilityId?: string
  deductible?: number
  coinsurance?: number
  copayment?: number
  outOfPocketMax?: number | null
}

export interface ShopperEstimateData extends BaseModelData {
  eid?: string
  facilityId?: string
  patientFirstName?: string
  patientLastName?: string
  patientDOB?: string
  patientPhone?: string
  patientEmail?: string
  insurances?: { P?: ShopperEstimateInsurance }
  charges?: EstimateCharge[]
  inputs?: EstimateInputs
  output?: EstimateOutput
  eligibilityId?: string
  createdBy?: string | ShopperEstimateClinicianData
  status?: ShopperEstimate.STATUS
}

@CRUD({
  base: '/crud/shopper-estimates',
})
export class ShopperEstimate extends CrudModel {
  facilityId?: string
  patientFirstName = ''
  patientLastName = ''
  patientDOB?: string
  patientPhone?: string
  patientEmail?: string
  insurances?: { P?: ShopperEstimateInsurance }
  charges?: EstimateCharge[]
  inputs?: EstimateInputs
  output?: EstimateOutput
  eligibilityId?: string
  createdBy?: string | ShopperEstimateClinicianData
  status = ShopperEstimate.STATUS.DRAFT

  constructor(data?: ShopperEstimateData) {
    super(data, true)

    this.facilityId = data?.facilityId
    this.patientFirstName = data?.patientFirstName ?? ''
    this.patientLastName = data?.patientLastName ?? ''
    this.patientDOB = data?.patientDOB
    this.patientPhone = data?.patientPhone
    this.patientEmail = data?.patientEmail
    this.insurances = data?.insurances
    this.charges = data?.charges
    this.inputs = data?.inputs
    this.output = data?.output
    this.eligibilityId = data?.eligibilityId
    this.createdBy = data?.createdBy
    this.status = data?.status ?? ShopperEstimate.STATUS.DRAFT
  }

  get patientName(): string {
    return [this.patientFirstName, this.patientLastName].filter(Boolean).join(' ').trim()
  }

  get url(): string {
    return `/shopper-estimates/${this.id}`
  }

  override toJSON() {
    return {
      ...super.toJSON(),
      facilityId: this.facilityId,
      patientFirstName: this.patientFirstName,
      patientLastName: this.patientLastName,
      patientDOB: this.patientDOB,
      patientPhone: this.patientPhone,
      patientEmail: this.patientEmail,
      insurances: this.insurances,
      charges: this.charges,
      inputs: this.inputs,
      output: this.output,
      eligibilityId: this.eligibilityId,
      createdBy: this.createdBy,
      status: this.status,
    }
  }
}

export namespace ShopperEstimate {
  export enum STATUS {
    DRAFT = 'D',
    FINALIZED = 'F',
  }
}
